import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const polizaSeguroPdf = (data) => {
  const { poliza, empresa } = data;
  
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;

  
  const layoutTabla = {
    hLineWidth: function (i, node) { return 1; },
    vLineWidth: function (i, node) { return 1; },
    hLineColor: function (i, node) { return "#e8e8e8"; },
    vLineColor: function (i, node) { return "#e8e8e8"; },
    fillColor: function (rowIndex, node, columnIndex) {
        return (rowIndex % 2 === 0) ? '#f9f9f9' : null;
    }
  };

  const estiloHeaderTabla = {
      bold: true,
      fontSize: 10,
      color: 'black',
      fillColor: '#dedede', 
      margin: [5, 5, 5, 5]
  };

  const estiloCelda = {
      fontSize: 10,
      margin: [5, 5, 5, 5]
  };

  var dd = {
    content: [
      
      {
        style: 'tableExample',
        table: {
          widths: ['20%', '50%', '30%'],
          layout: 'noBorders',
          body: [
            [
              
              ...HeaderEmpresaCard(empresa, mostrarRegimen, false, 
                {
                    border: [false, false, false, false],
                    table: {
                  headerRows: 1,
                  widths: ['100%'],
                  body : [
                    [
                        {
                            text: 'N° Póliza:',
                            style: 'subheader',
                            alignment: 'center'
                        }
                    ],
                     [
                      {
                        text: poliza?.numero,
                        style: 'textoChico',
                        alignment: 'center'
                      }
                    ],
                    [
                      {
                        text: 'Generado:',
                        style: 'subheader',
                        alignment: 'center'
                      }
                    ],
                    [
                      {
                        text: moment().format('DD/MM/YYYY'),
                        style: 'subheader',
                        alignment: 'center'
                      }
                    ],
                  ]
                    },
                    layout: 'noBorders'
                }
              )
            ]
          ]
        }
      },
      
      { text: ' ', margin: [0, 10] }, 

      
      {
        style: 'tableExample',
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            
            [
                { text: 'Aseguradora', style: estiloHeaderTabla },
                { text: poliza.aseguradora, style: estiloCelda, colSpan: 3 },
                {}, {} 
            ],
            
            [
                { text: 'No. Póliza', style: estiloHeaderTabla },
                { text: poliza.numero, style: estiloCelda },
                { text: 'Frecuencia Pago', style: estiloHeaderTabla },
                { text: poliza.frecuenciaPago, style: estiloCelda }
            ],
            
            [
                { text: 'Vigencia Inicio', style: estiloHeaderTabla },
                { text: moment(poliza.fechaInicio).format('DD/MM/YYYY'), style: estiloCelda },
                { text: 'Vigencia Fin', style: estiloHeaderTabla },
                { text: poliza.fechaFin ? moment(poliza.fechaFin).format('DD/MM/YYYY') : 'Indefinida', style: estiloCelda }
            ]
          ]
        },
        layout: {
            hLineWidth: (i) => 1,
            vLineWidth: (i) => 1,
            hLineColor: '#bdbdbd',
            vLineColor: '#bdbdbd'
        }
      },

      { text: ' ', margin: [0, 5] },

      
      {
          table: {
              widths: ['100%'],
              body: [
                  [{ text: 'Descripción / Observaciones', style: estiloHeaderTabla }],
                  [{ text: poliza.descripcion || 'Sin descripción', style: estiloCelda, minHeight: 40 }]
              ]
          },
          layout: {
            hLineWidth: (i) => 1,
            vLineWidth: (i) => 1,
            hLineColor: '#bdbdbd',
            vLineColor: '#bdbdbd'
        }
      },

      { text: ' ', margin: [0, 5] },

      
      {
        table: {
          widths: ['33%', '33%', '34%'],
          body: [
            [
                { text: 'Monto por Pago', style: estiloHeaderTabla, alignment: 'right' },
                { text: 'Costo Total', style: estiloHeaderTabla, alignment: 'right' },
                { text: 'Moneda', style: estiloHeaderTabla, alignment: 'center' },
            ],
            [
                { text: dineroDisabledMask(poliza.montoPago), style: estiloCelda, alignment: 'right' },
                { text: dineroDisabledMask(poliza.total), style: { ...estiloCelda, bold: true, }, alignment: 'right' },
                { text: poliza.moneda || 'MXN', style: estiloCelda, alignment: 'center' },
            ]
          ]
        },
        layout: layoutTabla
      },

      
      {
          margin: [0, 80, 0, 0], 
          stack: [
              {
                  canvas: [{ type: 'line', x1: 0, y1: 0, x2: 200, y2: 0, lineWidth: 1 }]
              },
              {
                  text: 'Firma de Autorización',
                  style: 'textoChico',
                  alignment: 'center', 
                  margin: [0, 5, 0, 0] 
              }
          ],
          alignment: 'center' 
      }
    ],

    
    images: {
      logo: empresa.logo?.base64Completa ? empresa.logo.base64Completa : '',
    },
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: 'black' },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: 'black',
        alignment: 'center'
      },
      textoChico: { fontSize: 8 },
      textoChicoData: { fontSize: 6 },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: '#cccccc',
        style: 'subheader',
        alignment: 'center',
        border: true
      },
      textoTabla: { fontSize: 8, italics: false },
      textoTablaChico: { fontSize: 6, italics: false },
      descuentoPartida: {
        fontSize: 5,
        color: "#777",
      }
    },
    pageSize: 'LETTER',
    pageMargins: [40, 40, 40, 40]
  };
  
  return dd;
};

export default polizaSeguroPdf;